<template>
  <div id="app" :class="appContainerClass">

    <NavBar v-if="$route.meta.navBarFlag" />


    <keep-alive :include="include">
      <router-view v-if="isRouterAlive && $route.meta.keepAlive" />
    </keep-alive>


    <router-view v-if="isRouterAlive && !$route.meta.keepAlive" />

    <!-- <router-view v-if="isRouterAlive" /> -->

    <TabBar v-if="$route.meta.tabBarFlag && !isExpertEndAccessingSupplierPage && !isReplenishmentPage" />
    <TabBarSupp v-if="$route.meta.tabBarFlag && !isExpertEndAccessingSupplierPage && !isReplenishmentPage" />
    <TabBarShare v-if="$route.meta.tabBarFlag && !isExpertEndAccessingSupplierPage && !isReplenishmentPage" />
    <TabBarReplenishment v-if="$route.meta.tabBarFlag && !isExpertEndAccessingSupplierPage && isReplenishmentPage && isReplenishmentUser" />
    <!-- 小店专用TabBar -->
    <TabBarSmallShop v-if="$route.meta.tabBarFlag && isSmallShopPage" />
    
    <!-- 隐私政策弹窗 -->
    <van-overlay :show="showPrivacyDialog" class-name="privacy-overlay flex aic jcc" :z-index="9999">
      <div class="privacy-wrapper">
        <!-- <div class="privacy-welcome-text">欢迎使用APP</div> -->
        <div class="privacy-dialog-box">
          <div class="privacy-title">隐私政策</div>
          <div class="privacy-content">
            <div class="privacy-text">本应用尊重并保护所有用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照隐私政策的规定使用和披露您的个人信息。</div>
            <div class="privacy-links">
              可阅读<span class="link-text" @click="goToServiceAgreement">服务协议</span>和<span class="link-text" @click="goToPrivacyPolicy">隐私政策</span>。
            </div>
          </div>
          <div class="privacy-buttons">
            <div class="privacy-btn agree-btn" @click="handleAgree">同意</div>
            <div class="privacy-btn disagree-btn" @click="handleDisagree">不同意并退出APP</div>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import NavBar from "@components/navBar";
import TabBar from "@components/tabBar";
import TabBarSupp from "@components/tabBarSupp";
import TabBarShare from "@components/tabBarShare";
import TabBarReplenishment from "@components/TabBarReplenishment";
import TabBarSmallShop from "@components/tabBarSmallShop";
import * as orderApi from "@/api/order";
import * as smallShopApi from "@/api/smallShop";
import { initPush } from "@/utils/push";

export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      carCount: 0,
      // 提供店铺信息给子组件
      getSmallShopInfo: this.getSmallShopInfo,


    }
  },
  components: {
    TabBar,
    NavBar,
    TabBarSupp,
    TabBarShare,
    TabBarReplenishment,
    TabBarSmallShop
  },
  data() {
    return {
      isRouterAlive: true,
      accountType: JSON.parse(
        sessionStorage.getItem("userInfoXpz")
      )?.accountType,
      include: [],
      showPrivacyDialog: false
    }
  },
  computed: {
    // 判断是否为达人端访问供应商页面
    isExpertEndAccessingSupplierPage() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfoXpz"));
      const accountType = userInfo?.accountType;

      // 如果是达人端用户(accountType === 5)且当前路由是供应商相关页面
      if (accountType === 5) {
        const supplierRoutes = [
          '/suppClassification',
          '/suppReleases',
          '/mineSupp',
          '/mineHome'
        ];
        return supplierRoutes.includes(this.$route.path);
      }

      return false;
    },
    // 判断是否为配货端页面（包含分享免登录入口）
    isReplenishmentPage() {
      const replenishmentRoutes = [
        '/replenishment',
        '/replenishmentOrder',
        '/replenishmentOrderDetail',
        '/orderSuccess',
        '/replenishmentMine',
        '/replenishmentShare' // 分享免登录入口也视为配货页
      ];
      return replenishmentRoutes.includes(this.$route.path);
    },
    // 判断是否为配货端用户
    isReplenishmentUser() {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfoXpz") || '{}');
      const accountType = userInfo?.accountType;
      return accountType === 6;
    },
    // 判断是否为小店页面
    isSmallShopPage() {
      const smallShopRoutes = [
        '/smallShop/home',
        '/smallShop/order',
        '/smallShop/mine'
      ];
      return smallShopRoutes.includes(this.$route.path);
    },
    // 判断是否为秒杀页面（不需要安全区）
    isSeckillPage() {
      return this.$route.path.includes('/seckill/');
    },
    // 控制 #app 容器的类名
    appContainerClass() {
      return {
        'seckill-container': this.isSeckillPage
      };
    }
  },
  watch: {
    $route(to, from) {
      //如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
      if (to.meta.keepAlive) {
        !this.include.includes(to.name) && this.include.push(to.name);
      }
      //如果 要 form(离开) 的页面是 keepAlive缓存的，
      //再根据 deepth 来判断是前进还是后退
      //如果是后退
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }
      console.log(this.include)
      
      // 如果从隐私政策或服务协议页面返回，且用户还未同意，重新显示弹窗（仅在App环境）
      if ((from.path === '/viewPrivacy' || from.path === '/viewPriClient') && 
          to.path !== '/viewPrivacy' && to.path !== '/viewPriClient') {
        // 只在App环境下才显示隐私政策弹窗
        if (this.isAppEnvironment()) {
          const hasAgreed = localStorage.getItem('privacyAgreementAgreed');
          if (!hasAgreed) {
            this.$nextTick(() => {
              this.showPrivacyDialog = true;
            });
          }
        }
      }
    }
  },
  mounted() {
    // 只有当路由 query.type 为 8 时才初始化获取店铺信息
    if (this.$route && this.$route.query && Number(this.$route.query.type) === 8) {
      this.initSmallShopInfo();
    }
    // 检查是否需要显示隐私政策弹窗
    this.checkPrivacyAgreement();
    // this.init();
    // function onBridgeReady() {
    //   window.WeixinJSBridge.call('hideToolbar');
    // }
    // if (typeof window.WeixinJSBridge == "undefined") {
    //   document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    // } else {
    //   onBridgeReady();
    // }
  },

  methods: {
    // 初始化获取店铺信息并存储
    async initSmallShopInfo() {
      try {
        const res = await smallShopApi.shopInfo();
        if (res.status && res.ret) {
          // 存储到 sessionStorage
          sessionStorage.setItem('smallShopInfo', JSON.stringify(res.ret));
          console.log('店铺信息已获取并存储:', res.ret);
        }
      } catch (error) {
        console.error('获取店铺信息失败:', error);
      }
    },
    // 获取店铺信息（从缓存或重新请求）
    async getSmallShopInfo() {
      // 先从缓存读取
      const cached = sessionStorage.getItem('smallShopInfo');
      if (cached) {
        return JSON.parse(cached);
      }
      // 如果没有缓存，重新请求
      try {
        const res = await smallShopApi.shopInfo();
        if (res.status && res.ret) {
          sessionStorage.setItem('smallShopInfo', JSON.stringify(res.ret));
          return res.ret;
        }
      } catch (error) {
        console.error('获取店铺信息失败:', error);
      }
      return null;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    //获取购物车列表数量
    async getCarCount() {
      let res = await orderApi.carCountInfo();
      if (res.status) {
        this.carCount = res.ret.count
      } else {
        this.$toast(res.msg);
      }
    },
    async init() {
      //根据用户角色显示 要显示的角色首页 0运营端，1客户，2供应商，5达人端
      let accountType = JSON.parse(
        sessionStorage.getItem("userInfoXpz")
      )?.accountType;
      if (accountType == 1) {
        //  客户端首页
        this.accountType = 1
        this.getCarCount()
      }
      if (accountType == 4) {
        //  客户端首页
        this.accountType = 4
        this.getCarCount()
      }
      if (accountType == 2) {
        //   供应商
        this.accountType = 2
      }
      if (accountType == 5) {
        //   达人端
        this.accountType = 5
      }
    },
    // 检查是否为App环境
    isAppEnvironment() {
      try {
        // 方法1: 检查body是否有capacitor-app类（main.js中会添加）
        if (typeof document !== 'undefined' && document.body && document.body.classList.contains('capacitor-app')) {
          return true;
        }
        // 方法2: 检查Capacitor API
        if (typeof window !== 'undefined' && window.Capacitor && 
            typeof window.Capacitor.isNativePlatform === 'function' && 
            window.Capacitor.isNativePlatform()) {
          return true;
        }
      } catch (e) {
        console.warn('检测App环境失败:', e);
      }
      return false;
    },
    // 检查隐私政策同意状态
    checkPrivacyAgreement() {
      // 只在App环境下才显示隐私政策弹窗
      if (!this.isAppEnvironment()) {
        return;
      }
      
      const hasAgreed = localStorage.getItem('privacyAgreementAgreed');
      // 如果用户已经同意过，不再显示弹窗
      if (!hasAgreed) {
        // 延迟显示，确保页面已加载
        this.$nextTick(() => {
          this.showPrivacyDialog = true;
        });
      }
    },
    // 同意隐私政策
    async handleAgree() {
      // 保存同意状态，用户下次进入不会再显示弹窗
      localStorage.setItem('privacyAgreementAgreed', 'true');
      // 同时保存时间戳，方便后续可能需要重新确认的情况
      localStorage.setItem('privacyAgreementTime', Date.now().toString());
      this.showPrivacyDialog = false;

      // 同步到原生（SharedPreferences），用于在 App 启动阶段（Provider）阻断同意前的设备标识采集
      // 注：只有在 Cordova/Capacitor 原生环境且插件存在时才会执行
      this.syncNativePrivacyConsent(true);

      // 用户同意后再初始化推送服务（极光 / FCM 等）
      if (this.isAppEnvironment()) {
        try {
          await initPush();
          console.log('[App] Push service initialized after privacy agreement');
        } catch (e) {
          console.warn('[App] Failed to initialize push service after agreement:', e);
        }
      }
    },
    // 不同意并退出
    handleDisagree() {
      // 显示提示信息
      this.$toast && this.$toast('您需要同意隐私政策才能使用本应用');

      // 明确告知原生当前未授权（兜底），避免下次启动误认为已同意
      this.syncNativePrivacyConsent(false);
      
      // 尝试关闭窗口或退出应用
      // 微信环境
      if (typeof window.WeixinJSBridge !== 'undefined') {
        window.WeixinJSBridge.call('closeWindow');
        return;
      }
      
      // 检查是否在微信中
      const ua = navigator.userAgent || '';
      if (/MicroMessenger/i.test(ua)) {
        // 微信中但WeixinJSBridge未准备好，等待一下再试
        if (typeof window.WeixinJSBridge === 'undefined') {
          document.addEventListener('WeixinJSBridgeReady', () => {
            window.WeixinJSBridge.call('closeWindow');
          }, false);
        }
        return;
      }
      
      // 其他环境（如浏览器、App内嵌等）
      // 在浏览器中，window.close()通常无效（除非窗口是通过脚本打开的）
      // 在App内嵌环境中，可能需要调用原生方法
      try {
        // 尝试关闭窗口
        if (window.close) {
          window.close();
        }
      } catch (e) {
        console.log('无法关闭窗口，用户需要手动退出');
        // 如果无法关闭，至少提示用户
        this.$toast && this.$toast('请手动退出应用');
      }
    },
    // 跳转到服务协议
    goToServiceAgreement() {
      this.showPrivacyDialog = false;
      this.$router.push({ path: '/viewPriClient' });
    },
    // 跳转到隐私政策
    goToPrivacyPolicy() {
      this.showPrivacyDialog = false;
      this.$router.push({ path: '/viewPrivacy' });
    },

    // 将隐私同意状态同步到原生侧（用于 JCore/JPush 合规开关 & SharedPreferences 持久化）
    syncNativePrivacyConsent(agreed) {
      try {
        if (!this.isAppEnvironment()) return;
        const val = !!agreed;
        // JPush: window.JPush.setAuth
        if (typeof window !== 'undefined' && window.JPush && typeof window.JPush.setAuth === 'function') {
          window.JPush.setAuth(val);
        }
        // JCore: window.JCore.setAuth
        if (typeof window !== 'undefined' && window.JCore && typeof window.JCore.setAuth === 'function') {
          window.JCore.setAuth(val);
        }
      } catch (e) {
        console.warn('[App] syncNativePrivacyConsent failed:', e);
      }
    },
  }
};
</script>

<style lang="scss">
.page {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 1rem;
}

::v-deep .van-nav-bar__title {
  font-size: 0.34rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2a2b2e;
}

// 隐私政策弹窗样式
::v-deep .privacy-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.3);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

.privacy-wrapper {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 0.4rem;
  position: relative;
  box-sizing: border-box;
  // margin-top: 1.6rem;
  .privacy-welcome-text {
    font-size: 0.28rem;
    color: #999;
    text-align: center;
    margin-bottom: 0.3rem;
  }
  
  .privacy-dialog-box {
    width: 100%;
    max-width: 6.2rem;
    background: #fff;
    border-radius: 0.2rem;
    padding: 0.6rem 0.4rem 0.4rem;
    box-sizing: border-box;
    
    .privacy-title {
      font-size: 0.36rem;
      font-weight: 600;
      color: #2a2b2e;
      text-align: center;
      margin-bottom: 0.3rem;
      text-decoration: underline;
      padding-bottom: 0.2rem;
    }
    
    .privacy-content {
      padding: 0 0.2rem;
      margin-bottom: 0.4rem;
      
      .privacy-text {
        font-size: 0.28rem;
        color: #2a2b2e;
        line-height: 1.6;
        margin-bottom: 0.2rem;
        text-indent: 0;
      }
      
      .privacy-links {
        font-size: 0.28rem;
        color: #2a2b2e;
        line-height: 1.6;
        text-indent: 0;
        
        .link-text {
          color: #1989fa;
          text-decoration: underline;
          cursor: pointer;
          margin: 0 0.05rem;
          
          &:active {
            opacity: 0.7;
          }
        }
      }
    }
    
    .privacy-buttons {
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      padding-top: 0.2rem;
      
      .privacy-btn {
        width: 100%;
        height: 0.88rem;
        border-radius: 0.44rem;
        font-size: 0.32rem;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: opacity 0.2s;
        color: #fff;
        
        &:active {
          opacity: 0.8;
        }
      }
      
      .agree-btn {
        background: linear-gradient(90deg, #ff4961 0%, #ff3954 50%, #fe2744 100%);
      }
      
      .disagree-btn {
        background: linear-gradient(90deg, #ff4961 0%, #ff3954 50%, #fe2744 100%);
      }
    }
  }
}
</style>
